import React from 'react';
import { Icon } from './Icon.js';
export const IconBookmark = ({ ...props }) => {
    return (React.createElement(Icon, { size: "24px", ...props },
        React.createElement("path", { d: "M4 2H20V21.5L12 17.5L4 21.5V2Z", stroke: "currentColor", strokeWidth: "2", fill: "none" })));
};
//# sourceMappingURL=IconBookmark.js.map